<template>
  <div>
    <section class="page-block">
      <h2>快速开始</h2>
      <div class="project-card create-card" @click="openCreateModal">+ 创建项目</div>
    </section>
    <section class="page-block">
      <h2>我的项目</h2>
      <div class="project-grid">
        <div v-for="item in projects" :key="item.id" class="project-card" @click="goToProject(item)">
          <div class="project-cover-wrap">
            <div v-if="shouldShowCoverPlaceholder(item)" class="project-cover placeholder-block video-placeholder">
              <div class="video-placeholder-card">
                <span class="video-placeholder-play"></span>
              </div>
            </div>
            <img
              v-else
              class="project-cover"
              :src="coverSrc(item)"
              :alt="item.title"
              @error="onProjectCoverError(item)"
            />
            <div class="project-item-actions">
              <button type="button" class="icon-btn icon-btn-edit" title="编辑" @click.stop="openEditModal(item)">
                <svg
                  class="icon-edit-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </button>
              <button type="button" class="icon-btn" title="删除" @click.stop="deleteProject(item)">🗑</button>
            </div>
          </div>
          <div class="project-info project-info-home">
            <span class="project-title-text">{{ item.title }}</span>
            <small class="project-update-text">{{ item.updateText }}</small>
          </div>
        </div>
      </div>
    </section>

    <div v-if="modalVisible" class="mask" @click.self="closeModal">
      <div class="project-modal" :class="{ 'edit-mode': modalMode === 'edit' }">
        <button class="modal-close" @click="closeModal">×</button>
        <h3>{{ modalMode === "create" ? "创建项目" : "编辑项目" }}</h3>

        <div class="project-form-item">
          <label>项目名称</label>
          <input
            v-model.trim="form.title"
            maxlength="50"
            :placeholder="modalMode === 'create' ? '请输入项目名称' : '请输入项目名称'"
          />
          <div class="word-count">{{ form.title.length }}/50</div>
        </div>

        <template v-if="modalMode === 'create'">
          <div class="project-form-item">
            <label>画幅</label>
            <div class="select-grid ratio-grid">
              <button
                v-for="item in ratioOptions"
                :key="item.value"
                class="select-card"
                :class="{ active: form.ratio === item.value }"
                @click="form.ratio = item.value"
              >
                {{ item.label }}
              </button>
            </div>
          </div>

          <div class="project-form-item">
            <label>类型</label>
            <div class="select-grid">
              <button
                v-for="item in typeOptions"
                :key="item.value"
                class="select-card type-card"
                :class="{ active: form.type === item.value }"
                @click="onCreateTypePick(item.value)"
              >
                <strong>{{ item.label }}</strong>
                <span>{{ item.desc }}</span>
              </button>
            </div>
          </div>

          <div class="project-form-item">
			  <!-- 视频生成语言 -->
            <label>视频语言</label>
            <div class="select-grid ratio-grid">
              <button
                v-for="item in videoLangOptions"
                :key="item.value"
                class="select-card"
                :class="{ active: form.videoPromptLanguage === item.value }"
                @click="form.videoPromptLanguage = item.value"
              >
                {{ item.label }}
              </button>
            </div>
            <!-- <div class="field-hint">用于视频模型提示词（默认中文）。</div> -->
          </div>

          <div class="project-form-item">
            <label>视频生成模式</label>
            <div class="select-grid mode-grid">
              <button
                v-for="item in videoGenerateModeOptions"
                :key="item.value"
                class="select-card mode-card"
                :class="{ active: form.videoGenerateMode === item.value }"
                @click="form.videoGenerateMode = item.value"
                type="button"
              >
                <strong>{{ item.label }}</strong>
                <span>{{ item.desc }}</span>
              </button>
            </div>
            <div class="field-hint">{{ videoGenerateModeHint }}</div>
          </div>
        </template>

        <template v-else>
          <div class="project-form-item">
            <label>视频生成语言</label>
            <div class="select-grid ratio-grid">
              <button
                v-for="item in videoLangOptions"
                :key="item.value"
                class="select-card"
                :class="{ active: form.videoPromptLanguage === item.value }"
                @click="form.videoPromptLanguage = item.value"
              >
                {{ item.label }}
              </button>
            </div>
            <div class="field-hint">用于步骤一与步骤四视频生成提示词。</div>
          </div>

          <div class="project-form-item">
            <label>视频生成模式</label>
            <div class="select-grid mode-grid">
              <button
                v-for="item in videoGenerateModeOptions"
                :key="item.value"
                class="select-card mode-card"
                :class="{ active: form.videoGenerateMode === item.value }"
                @click="form.videoGenerateMode = item.value"
                type="button"
              >
                <strong>{{ item.label }}</strong>
                <span>{{ item.desc }}</span>
              </button>
            </div>
            <div class="field-hint">{{ videoGenerateModeHint }}</div>
          </div>

          <div class="project-form-item">
            <label>封面图</label>
            <div class="upload-cover-box">
              <img v-if="form.cover" :src="form.cover" alt="cover" />
              <div v-else class="upload-placeholder">
                <div class="upload-icon">⇪</div>
                <div>点击上传或拖拽文件到此处</div>
                <small>支持 jpeg、png，大小不超过 1MB</small>
              </div>
            </div>
          </div>
        </template>

        <div class="modal-footer">
          <button class="secondary-btn footer-btn" @click="closeModal">取消</button>
          <button class="main-btn footer-btn" @click="submitProject">
            {{ modalMode === "create" ? "确定创建" : "保存编辑" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from "../api/user";
import { HOME_PROJECTS_CACHE_KEY } from "../constants/projectCache";

export default {
  name: "HomePage",
  data() {
    return {
      projects: [],
      modalVisible: false,
      modalMode: "create",
      editingProjectId: null,
      form: this.getDefaultForm(),
      ratioOptions: [
        { label: "16:9", value: "16:9" },
        { label: "9:16", value: "9:16" }
      ],
      typeOptions: [
        { label: "剧情演绎", value: "剧情演绎", desc: "以角色对白和剧情为主" },
        { label: "旁白解说", value: "旁白解说", desc: "以旁白叙述为主" }
      ],
      videoLangOptions: [
        { label: "中文", value: "zh" },
        { label: "English", value: "en" }
      ],
      videoGenerateModeOptions: [
        { value: "grid", label: "九宫格模式", desc: "先生成九宫格分镜参考图，再生成视频" },
        { value: "reference", label: "参考图模式", desc: "直接使用角色/场景参考图，不生成九宫格" }
      ],
      videoGenerateModeHint: "步骤四生成视频时使用：九宫格模式会先出分镜排布再出视频；参考图模式直接用现有参考图出视频，耗时更短。"
    };
  },
  async created() {
    try {
      const data = await userApi.projects();
      if (Array.isArray(data)) {
        this.projects = data;
      }
    } catch (e) {
      // keep empty state as fallback
    }
    try {
      const d = await userApi.setupDictionary();
      if (d && Array.isArray(d.aspectRatio) && d.aspectRatio.length) {
        this.ratioOptions = d.aspectRatio.map(x => ({
          label: x.label || x.value,
          value: x.value
        }));
      }
      if (d && Array.isArray(d.projectType) && d.projectType.length) {
        this.typeOptions = d.projectType.map(x => ({
          label: x.label || x.value,
          value: x.value,
          desc: x.desc || ""
        }));
      }
      if (d && Array.isArray(d.videoPromptLanguage) && d.videoPromptLanguage.length) {
        this.videoLangOptions = d.videoPromptLanguage.map(x => ({
          label: x.label || x.value,
          value: x.value === "en" ? "en" : "zh"
        }));
      }
    } catch (e) {
      /* 使用 data 内默认画幅与类型 */
    }
  },
  methods: {
    isPlaceholderAsset(src) {
      const s = String(src || "").trim();
      if (!s) return true;
      return /dummyimage\.com/i.test(s);
    },
    /** 同源相对路径（/storage、/uploads）走 devServer 代理；烂图走 @error 回退占位 */
    mediaUrl(src) {
      const s = String(src || "").trim();
      if (!s) return "";
      if (/^https?:\/\//i.test(s)) return s;
      return s.startsWith("/") ? s : `/${s}`;
    },
    coverSrc(item) {
      return this.mediaUrl(item && item.cover);
    },
    shouldShowCoverPlaceholder(item) {
      return this.isPlaceholderAsset(item.cover) || !!item._coverBroken;
    },
    onProjectCoverError(item) {
      if (item && !item._coverBroken) {
        this.$set(item, "_coverBroken", true);
      }
    },
    syncProjectsCache() {
      // 首页项目在创建/编辑后会被后续创作流程页读取，所以这里做本地缓存。
      sessionStorage.setItem(HOME_PROJECTS_CACHE_KEY, JSON.stringify(this.projects));
    },
    getDefaultForm() {
      return {
        title: "",
        ratio: "16:9",
        type: "剧情演绎",
        cover: "",
        videoPromptLanguage: "zh",
        visualStyleCode: "1",
        videoGenerateMode: "reference"
      };
    },
    onCreateTypePick(value) {
      this.form.type = value;
      if (value === "商品讲解") {
        this.form.ratio = "16:9";
      }
      if (value === "MG动画") {
        this.form.ratio = "16:9";
        this.form.visualStyleCode = "31";
      } else if (String(this.form.visualStyleCode || "") === "31") {
        this.form.visualStyleCode = "1";
      }
    },
    openCreateModal() {
      const token = localStorage.getItem("user_token");
      if (!token) {
        this.$root.$emit("open-login");
        return;
      }
      this.modalMode = "create";
      this.editingProjectId = null;
      this.form = this.getDefaultForm();
      this.modalVisible = true;
    },
    openEditModal(project) {
      this.modalMode = "edit";
      this.editingProjectId = project.id;
      this.form = {
        title: project.title || "",
        ratio: project.ratio || "16:9",
        type: project.type || "剧情演绎",
        cover: project.cover || "",
        videoPromptLanguage: project.videoPromptLanguage === "en" ? "en" : "zh",
        videoGenerateMode: project.videoGenerateMode === "reference" ? "reference" : "grid"
      };
      this.modalVisible = true;
    },
    goToProject(item) {
      this.$router.push({
        path: "/project/setup",
        query: { id: item.id, title: item.title || "" }
      });
    },
    async deleteProject(item) {
      const title = item.title || "当前项目";
      const msg =
        `确定要删除项目「${title}」吗？\n\n` +
        `删除后无法恢复，并将清空与该项目相关的全部内容，包括：\n` +
        `· 角色、场景、素材等主体及参考图\n` +
        `· 全部分集及分集与主体的绑定关系\n` +
        `· 所有镜头、分镜描述与已关联的九宫格/视频记录\n` +
        `· 步骤一脚本草稿与项目内模型选择等草稿\n` +
        `· 该项目下的异步生成任务队列\n` +
        `· 项目本身`;
      if (!window.confirm(msg)) return;
      const token = localStorage.getItem("user_token");
      if (!token) {
        this.$root.$emit("open-login");
        return;
      }
      try {
        await userApi.deleteProject(item.id);
        const data = await userApi.projects();
        this.projects = Array.isArray(data) ? data : [];
      } catch (e) {
        window.alert(e && e.message ? e.message : "删除失败");
      }
    },
    closeModal() {
      this.modalVisible = false;
    },
    async submitProject() {
      if (!this.form.title) {
        window.alert("请输入项目名称");
        return;
      }
      const token = localStorage.getItem("user_token");
      if (!token) {
        this.$root.$emit("open-login");
        return;
      }

      if (this.modalMode === "create") {
        try {
          const row = await userApi.createProject({
            title: this.form.title,
            ratio: this.form.ratio,
            type: this.form.type,
            cover: "",
            videoPromptLanguage: this.form.videoPromptLanguage === "en" ? "en" : "zh",
            visualStyleCode: String(this.form.visualStyleCode || "1").trim() || "1",
            videoGenerateMode: this.form.videoGenerateMode === "reference" ? "reference" : "grid"
          });
          this.projects.unshift(row);
          this.syncProjectsCache();
          this.modalVisible = false;
          this.$router.push({
            path: "/project/setup",
            query: { id: row.id, title: row.title || "" }
          });
        } catch (e) {
          window.alert(e && e.message ? e.message : "创建失败");
        }
        return;
      }

      try {
        const row = await userApi.updateProject({
          id: this.editingProjectId,
          title: this.form.title,
          ratio: this.form.ratio || "16:9",
          type: this.form.type || "剧情演绎",
          cover: this.form.cover || "",
          videoPromptLanguage: this.form.videoPromptLanguage === "en" ? "en" : "zh",
          videoGenerateMode: this.form.videoGenerateMode === "reference" ? "reference" : "grid"
        });
        this.projects = this.projects.map(p => (p.id === this.editingProjectId ? row : p));
        this.syncProjectsCache();
        this.modalVisible = false;
        this.$router.push({
          path: "/project/setup",
          query: { id: row.id, title: row.title || "", mode: "edit" }
        });
      } catch (e) {
        window.alert(e && e.message ? e.message : "保存失败");
      }
    }
  },
  watch: {
    projects: {
      handler() {
        this.syncProjectsCache();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.project-cover-wrap {
  position: relative;
}

.project-cover {
  width: 100%;
  border-radius: 10px;
  display: block;
  height:180px;
  -o-object-fit: cover;
    object-fit: cover;
}

.placeholder-block {
  background: #444444;
  aspect-ratio: 16 / 9;
}

.video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-placeholder-card {
  width: 44px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(20, 20, 20, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

.video-placeholder-play {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid rgba(255, 255, 255, 0.92);
  margin-left: 2px;
}

.project-grid .project-card:not(.create-card) {
  cursor: pointer;
}

.project-item-actions {
  position: absolute;
  right: 8px;
  top: 8px;
  display: flex;
  gap: 6px;
  z-index: 2;
}

.icon-btn {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  cursor: pointer;
  line-height: 1;
  font-size: 14px;
  padding: 0;
}

.icon-btn.danger {
  border-color: rgba(255, 120, 120, 0.8);
}

.icon-btn-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-edit-svg {
  width: 14px;
  height: 14px;
  display: block;
}

.project-info-home {
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  justify-content: flex-start;
}

.project-title-text {
  font-size: 15px;
  line-height: 1.35;
}

.project-update-text {
  color: #9a9a9a;
  font-size: 14px;
}

.project-modal {
  position: relative;
  width: 600px;
  background: #333333;
  border-radius: 16px;
  padding: 22px;
}

.project-modal.edit-mode {
  width: 520px;
}

.modal-close {
    position: absolute;
    right: 14px;
    top: 10px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

.project-form-item {
  margin-top: 18px;
}

.project-form-item label {
  display: block;
  margin-bottom: 10px;
  color: #dfdfdf;
}

.project-form-item input {
  width: 100%;
  height: 40px;
  background: #1f1f1f;
  border: 1px solid #3d3d3d;
  border-radius: 8px;
  color: #fff;
  padding: 0 12px;
}

.word-count {
  margin-top: 6px;
  text-align: right;
  color: #8c8c8c;
  font-size: 14px;
}

.select-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.ratio-grid .select-card {
  min-height: 52px;
}

.select-card {
  background: #252525;
  border: 1px solid #3e3e3e;
  border-radius: 10px;
  color: #e8e8e8;
  cursor: pointer;
  padding: 14px;
  text-align: left;
}

.select-card.active {
  border-color: #19b06b;
  box-shadow: inset 0 0 0 1px #19b06b;
}

.type-card {
  min-height: 92px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.type-card span {
  color: #9f9f9f;
  font-size: 14px;
}

.mode-grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.mode-card {
  min-height: 92px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  text-align: left;
}

.mode-card span {
  color: #9f9f9f;
  font-size: 14px;
  font-weight: 400;
}

.field-hint {
  margin-top: 8px;
  font-size: 14px;
  color: #8a8a8a;
  line-height: 1.4;
}

.upload-cover-box {
  min-height: 170px;
  background: #1f1f1f;
  border: 1px solid #3c3c3c;
  border-radius: 10px;
  padding: 12px;
}

.upload-cover-box img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
}

.upload-placeholder {
  min-height: 146px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b5b5b5;
  text-align: center;
  gap: 8px;
}

.upload-icon {
  font-size: 30px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}

.footer-btn {
  width: 110px;
}
</style>
